import "./index.scss";
// import { $ } from "@olmokit/dom";

/**
 * Component: VisualPlus
 */
export function VisualPlus() {
  console.log("VisualPlus mounted.");

  import("@olmokit/core/player").then(({ Player }) => {
    Player();    
  });
}
